/**
 * `/spaces/$spaceUuid` — a single space's canvas.
 *
 * Full-bleed: `SpaceCanvas` renders its own bordered panel + dotted
 * grid, so the route doesn't wrap it in an Island.
 */
import { SpaceCanvas } from '@/components/spaces/SpaceCanvas';
import { createFileRoute, redirect } from '@tanstack/react-router';
import type { ReactElement } from 'react';

export const Route = createFileRoute('/_app/spaces/$spaceUuid')({
  // Disabled surface — redirect any direct access to /performance.
  beforeLoad: () => {
    throw redirect({ to: '/performance' });
  },
  component: SpaceRoute,
});

function SpaceRoute(): ReactElement {
  const { spaceUuid } = Route.useParams();
  return <SpaceCanvas spaceUuid={spaceUuid} />;
}
